<template>
  <div style="min-height: 100vh;">
    <div v-if="!showWhitePage" style="min-height: 100vh;">
      <passInfo
          v-if="wechatEve"
          :history-detail="historyDetail"
          :face-img="faceImg"
          :qr-code="qrCodeImgUrl"
          :upload-suc="uploadSuc"
          @refreshUploadSuc="refreshUploadSuc"
          @refreshFaceImg="refreshFaceImg"
          @refreshInfo="() => getInfo(true)"
      />
      <div v-else class="checkPage">
        <div class="head">
          请输入手机号验证身份
        </div>
        <div class="phone">
          <input v-model.trim="phone" type="text">
        </div>
        <div class="btn">
          <van-button type="primary" @click="onMatch">匹配</van-button>
        </div>
      </div>
    </div>
    <div v-else class="whitePage">
      <div v-if="notFound">
        <div class="svgArea">
          <svg-icon icon-class="locked" class="none" />
        </div>
        <div class="back">
          <span @click="goBack">
            根据手机号未匹配到您的邀约记录
            <br />
            返回首页
          </span>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { inviteInfo } from '@/api/home'
import config from '@/common/config'
import passInfo from './facePassInfo'

export default {
  name: 'FaceAuth',
  components: {
    passInfo
  },
  data() {
    return {
      uploadSuc: false,
      notFound: false,
      headerTip: '请点击下方按钮上传您的头像用作通行凭证',
      faceImg: '',
      wechatEve: true,
      phone: '',
      historyDetail: {},
      qrCodeImgUrl: '',
      id: this.$route.query.id || '',
      baseURL: process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro,
      showWhitePage: true,
      inviteInfos: {
        visitorStatus: '',
        beVisitStaffName: '',
        visitDate: '',
        beVisitEdificeName: '',
        beVisitFloorName: ''
      },
      statusMap: {
        FACE: '人脸识别',
        IC: ' IC卡',
        QR: '二维码',
        '': '无'
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === 'staffMeetingHistoryDetail/:id/:activeName') {
        vm.getInfo(true);
      }
    });
  },
  created() {
    this.getInfo()
  },
  mounted() { },
  methods: {
    getInfo(refresh) {
      const data = {
        id: this.id
      }
      const ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        const personalInfo = localStorage.getItem('personalInfo')
        if (personalInfo) {
          const info = JSON.parse(personalInfo)
          data.phone = info.phone
          inviteInfo(data).then(res => {
            if (res.code === 200) {
              this.historyDetail = res.data
              this.historyDetail.visitDate = this.historyDetail.visitDate.slice(0, -3)
              this.uploadSuc = true
              this.faceImg = res.data.faceImg
              let auth = ''
              res.data.authTypes && res.data.authTypes.forEach((item, index) => {
                if (index === res.data.authTypes.length - 1) {
                  auth += this.statusMap[item]
                } else {
                  auth += `${this.statusMap[item]}、`
                }
              })
              this.historyDetail.authTypes = auth
              this.showWhitePage = false
            }
          }).catch(_ => {
            this.notFound = true
          })
        }
      } else { // 普通浏览器打开
        if (refresh) {
          this.onMatch()
        } else {
          this.wechatEve = false
          this.showWhitePage = false
        }
      }
    },
    onMatch() {
      const data = {
        id: this.id,
        phone: this.phone
      }
      inviteInfo(data).then(res => {
        if (res.code === 200) {
          this.historyDetail = res.data
          this.historyDetail.visitDate = this.historyDetail.visitDate.slice(0, -3)
          this.uploadSuc = true
          this.faceImg = res.data.faceImg
          let auth = ''
          res.data.authTypes && res.data.authTypes.forEach((item, index) => {
            if (index === res.data.authTypes.length - 1) {
              auth += this.statusMap[item]
            } else {
              auth += `${this.statusMap[item]}、`
            }
          })
          this.historyDetail.authTypes = auth
          this.showWhitePage = false
          this.wechatEve = true
        }
      })
    },
    refreshUploadSuc(val) {
      this.uploadSuc = val
    },
    refreshFaceImg(val) {
      this.uploadSuc = false;
      this.faceImg = val
    },
    goBack() {
      this.$router.push({ name: 'user' })
    }
  }
}
</script>

<style lang="less">
.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}
.checkPage {
  background-color: #FFFFFF;
  min-height: 100vh;
  .head {
    display: flex;
    justify-content: center;
    //padding: 1;
    .change_val(font-size, 42);
    .change_val(padding, 42);
  }
  .phone {
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: center;
    .change_val(margin, 20);

    input{
      width: 80%;
      text-align: center;
      background:none;
      outline:none;
      border:none;
      .change_val(font-size, 48);
      .change_val(padding, 2);
    }
  }

  .btn {
    display: flex;
    justify-content: center;
  }

}
.whitePage {
  background-color: #FFFFFF;
  min-height: 100vh;

  .svgArea {
    display: flex;
    justify-content: center;
    .none {
      .change_val(width, 350);
      .change_val(height, 350);
      .change_val(margin-top, 150);
    }
  }
  .back {
    display: flex;
    justify-content: center;
    .change_val(margin-top, 25);
    color: #3B86FF;
    .change_val(font-size, 28);

    span {
      text-align: center;
    }
  }

}
</style>
